import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'npc-action',
    templateUrl:'npcAction.html'
})
export class NpcActionComponent extends BaseActionComponent{
  public level=1;
  public itemNpcs=[]
  public npcId;
  public templateAvatar
  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
  }
  public npcConfig() {
    let domain=window.location.origin
    let url=domain+'/avatar?uid='+this._appData.instagramUser.uid+'&room='+this._appData.room.id+'&npc='+this._appData.object.objectId;
    url=url+'&dresser=1708116271394&cid=LIVEPLANET'
    window.location.replace(url);
  }
  public selectNpc(npc) {
    this.npcId = npc.id;
    for (let i = 0; i < this.itemNpcs.length; i++) {
      this.itemNpcs[i].selected = false;
      if (this.itemNpcs[i].id == npc.id) {
        this.itemNpcs[i].selected = true;
      }
    }
    if (npc.templateAvatar) {
      this.templateAvatar = npc.templateAvatar
    }

  }
  public voice
  public ia
  public reception
  public personality;
  public setPersonality(){
    this.personality=document.getElementById('personalityText')['value']
  }
  public chooseVoice(voice){
    this.voice=voice
  }
  public chooseIA(ia){
    this.ia=ia
  }
  public chooseReception(reception){
    this.reception=reception
  }
public processData(action){
    if (!action){
      action={kind:'npcTalk',param:{}}
    }

    if (this._appData.activeTrigger!='onClose'){
      action.param.npcId=this.npcId
      if (this._appData.company){
        action.param.company=this._appData.company.dbId
      }
    }
    else{
      action.param.reception=this.reception;
      action.param.reasoning={
        ia:this.ia,
        personality:this.personality
      }

    }


  }
  public childrenReloadData(){
    let action = this._appData.action;

    if (!action.param){action.param={}}
    if (action.param.reception){
      this.reception=action.param.reception
    }
    if (action.param.reasoning){
      this.ia=action.param.reasoning.ia
      try{
        document.getElementById('personalityText')['value']=(action.param.reasoning.personality)
      }
      catch (err){}
    }

    if (this.itemNpcs.length == 0) {
      let cid=0
      if (this._appData.room){
        cid=this._appData.room.company
      }
      else{
        cid=this._appData.company.dbId
      }
      if (this._appData.company){
      this._companyService.getAllCompanyNpcs().get().then(v => {
        this.itemNpcs=[]
        v.forEach(n => {
          let npc = n.data();
          npc.selected = false;
          if (action.param && action.param.npcId) {
            if (action.param.npcId == npc.id) {
              npc.selected = true;
            }
          }
          this.itemNpcs.push(npc)
        }

        )
      })

      }
      else{
        this._companyService.getAllNpcs().where('company', '==', cid).get().then(v => {
          this.itemNpcs=[]
          v.forEach(n => {
            let npc = n.data();
            npc.selected = false;
            if (action.param && action.param.npcId) {
              if (action.param.npcId == npc.id) {
                npc.selected = true;
              }
            }
            this.itemNpcs.push(npc)
          }

          )
        })

      }
    }
  }
    public ngOnInit(): any {
    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/npcAction.ts